import { render, staticRenderFns } from "./PageRepairHistory.vue?vue&type=template&id=ceb9456c&scoped=true"
import script from "./PageRepairHistory.vue?vue&type=script&lang=js"
export * from "./PageRepairHistory.vue?vue&type=script&lang=js"
import style0 from "./PageRepairHistory.vue?vue&type=style&index=0&id=ceb9456c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb9456c",
  null
  
)

export default component.exports